import _ from 'lodash';
import { GiactResponseCodes } from './../../coverpath-common/js/interfaces/CoverpathTypes';

export class GiactUtils {
  private static giactValidating: boolean = false;
  private static giactBlockingIds = ['1001'];
  private static letterFailureCodes = ['12', '09', '07'];

  static setGiactValidatingStatus(isValidating: boolean) {
    this.giactValidating = isValidating;
  }

  static isGiactBlockingId(id: string): boolean {
    return this.giactBlockingIds.includes(id);
  }

  static isLetterFailureCode(normalizedResponseCode: string): boolean {
    return this.letterFailureCodes.includes(normalizedResponseCode);
  }

  static isGiactValidating() {
    return this.giactValidating;
  }

  static isInvalidPayment(isGiactWebDebitValid, giactWebDebitResponseCode, giactLdFlagValue) {
    return isGiactWebDebitValid === false && giactWebDebitResponseCode && !_.isEmpty(giactLdFlagValue);
  }

  static getLoggedInUser(globalWindow) {
    if (globalWindow.amorphic.app === 'coverpath-client' || globalWindow.amorphic.app === 'mm-direct') {
      return 'Client';
    }
    // if non-client
    return globalWindow.controller.loggedInPrincipal.entitlement;
  }

  static getNormalizedGiactMessage(giactLdFlagValue, giactResponseCode) {
    if (giactResponseCode === GiactResponseCodes.SERVICE_OFF || _.isEmpty(giactLdFlagValue)) {
      return null;
    }

    if (giactResponseCode in giactLdFlagValue) {
      return giactLdFlagValue[giactResponseCode];
    }

    return giactLdFlagValue.DEFAULT;
  }
}
